import { doc } from "prettier";
import store from "../../Redux/store";
import {
  setDocuments,
  countDocuments,
  selectDocument,
  resetDocuments
} from "./Documents.reducer";

export function saveListDocuments(docs) {
  store.dispatch(setDocuments(docs));
}
export function saveCountDocuments(count) {
  store.dispatch(countDocuments(count));
}
export function saveSelectedDocument(doc) {
  store.dispatch(selectDocument(doc));
}
export const clearDocuments = () => store.dispatch(resetDocuments());